module.exports = __webpack_public_path__ + "static/media/background.2ea333d7.png";